export default "/staticreactui/static/media/static/media/customer2.370123ef.png";